'use client'

import { type Table } from '@tanstack/react-table'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { TranslationListItem } from '@/lib/api/translations'

interface TranslationsTableActionsProps {
    table: Table<TranslationListItem>
    onRefresh: () => void
    isLoading: boolean
    storeId: string
}

/**
 * TranslationsTableActions component for table toolbar actions
 */
export function TranslationsTableActions({ table, onRefresh, isLoading, storeId }: TranslationsTableActionsProps) {
    const { t } = useTranslation('languages')

    return (
        <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
                <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                {t('refresh')}
            </Button>
        </div>
    )
}

